/** Logs d’erreur réservés au dev — silence en production (polish / pas de bruit console). */
export function devError(...args: unknown[]): void {
  if (import.meta.env.DEV) {
    console.error(...args);
  }
}
